import Glide from "@glidejs/glide";
import { getElements, ifSelectorExist } from "./utils";

export const cherrySliders = () => {
    const reviewsSliderSidebar = ".google_reviews_slider_sidebar";
    if (ifSelectorExist(reviewsSliderSidebar) && document.querySelector(reviewsSliderSidebar) !== null) {
        Array.from(getElements(reviewsSliderSidebar)).forEach((item) => {
            new Glide(item, {
                perView: 1,
                type: "carousel",
                slideWidth: 1020,
            }).mount();
        });
    }
};